export default __webpack_public_path__ + "static/media/Foto-10.666be112.png";